import { type ButtonColorsType, useAppTheme } from '@capsicum/common';
import { useMemo } from 'react';
import { match } from 'ts-pattern';

import { MarketingBannerThemes } from '../models';

type UseMarketingBannerTextColorProps = {
	enabled: string;
	inverse: string;
	theme: MarketingBannerThemes;
};

export const useMarketingBannerTextColor = ({ enabled, inverse, theme }: UseMarketingBannerTextColorProps) => {
	const { mode } = useAppTheme();

	const { darkColor: darkTextColor, lightColor: lightTextColor } = useMemo(
		() =>
			match<typeof mode, Record<'darkColor' | 'lightColor', string>>(mode)
				.with('dark', () => ({
					darkColor: inverse,
					lightColor: enabled
				}))
				.otherwise(() => ({
					darkColor: enabled,
					lightColor: inverse
				})),
		[mode, enabled, inverse]
	);

	const { darkColor: darkButtonColor, lightColor: lightButtonColor } = useMemo(
		() =>
			match<typeof mode, Record<'darkColor' | 'lightColor', ButtonColorsType>>(mode)
				.with('dark', () => ({
					darkColor: 'inverse',
					lightColor: 'neutral'
				}))
				.otherwise(() => ({
					darkColor: 'neutral',
					lightColor: 'inverse'
				})),
		[mode]
	);

	return match(theme)
		.with(MarketingBannerThemes.PEPPER, () => ({ buttonColor: darkButtonColor, textColor: darkTextColor }))
		.otherwise(() => ({ buttonColor: lightButtonColor, textColor: lightTextColor }));
};
